<template>
    <div class="page">
    <ion-grid fixed>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Corporate Name
              </ion-label>
              <div class="section-desc margin-top-10">
                {{corporateName}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="corporateAliasName">
              <ion-label class="section-item" position="stacked">
                Corporate Alias Name
              </ion-label>
              <div class="section-desc margin-top-10">
                {{corporateAliasName}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Branch
              </ion-label>
              <div class="section-desc margin-top-10">
               {{branch}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Mobile#1
              </ion-label>
              <div class="section-desc margin-top-10">
                {{mobile1}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding" v-if="mobile2">
              <ion-label class="section-item" position="stacked">
                Mobile#2
              </ion-label>
              <div class="section-desc margin-top-10">
                {{mobile2}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="faxNumber">
              <ion-label class="section-item" position="stacked">
                Fax Number
              </ion-label>
              <div class="section-desc margin-top-10">
                {{faxNumber}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="landline">
              <ion-label class="section-item" position="stacked">
                Landline
              </ion-label>
              <div class="section-desc margin-top-10">
                {{landline}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="primaryContactPerson">
              <ion-label class="section-item" position="stacked">
                Primary Contact Person
              </ion-label>
              <div class="section-desc margin-top-10">
                {{primaryContactPerson}}
              </div>
            </ion-col>
            
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding" v-if="secondaryContactPerson">
              <ion-label class="section-item" position="stacked">
                Secondary Contact Person
              </ion-label>
              <div class="section-desc margin-top-10">
                {{secondaryContactPerson}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="gstNumber">
              <ion-label class="section-item" position="stacked">
                GST Number
              </ion-label>
              <div class="section-desc margin-top-10">
                {{gstNumber}}
              </div>
            </ion-col>
            <!-- <ion-col size="12" size-md="3" class="col-padding" v-if="panNo">
              <ion-label class="section-item" position="stacked">
                PAN Number
              </ion-label>
              <div class="section-desc margin-top-10">
                {{panNo}}
              </div>
            </ion-col> -->
            <ion-col size="12" size-md="3" class="col-padding" v-if="email">
              <ion-label class="section-item" position="stacked">
                Email
              </ion-label>
              <div class="section-desc margin-top-10">
                {{email}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="status">
              <ion-label class="section-item" position="stacked">
                Status
              </ion-label>
              <div class="section-desc status-small margin-top-10" v-bind:class="[{'status-active': status == 'A'}, {'status-inactive': status == 'I'}]">
                <!-- {{status | uppercase}} -->
                {{ convertUppercase(status) }}
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            
        <ion-col class="col-padding">
          <ion-label class="secondary-text">Address</ion-label>
        </ion-col>
      </ion-row>
      <ion-row align-items-stretch>
        <ion-col size="12" size-md="3" class="col-padding" v-if="line1">
          <ion-label class="section-item" position="stacked">
            Building Name
          </ion-label>
          <div class="section-desc margin-top-10">
            {{line1}}
          </div>
        </ion-col>
        <ion-col size="12" size-md="3" class="col-padding" v-if="line2">
          <ion-label class="section-item" position="stacked">
            Street Address
          </ion-label>
          <div class="section-desc margin-top-10">
            {{line2}}
          </div>
        </ion-col>
        <ion-col size="12" size-md="3" class="col-padding" v-if="line3">
          <ion-label class="section-item" position="stacked">
            Area Name
          </ion-label>
          <div class="section-desc margin-top-10">
            {{line3}}
          </div>
        </ion-col>
        <ion-col size="12" size-md="3" class="col-padding" v-if="city">
          <ion-label class="section-item" position="stacked"> City </ion-label>
          <div class="section-desc margin-top-10">
            {{city}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row align-items-stretch>
        <ion-col size="12" size-md="3" class="col-padding" v-if="state">
          <ion-label class="section-item" position="stacked"> State </ion-label>
          <div class="section-desc margin-top-10">
            {{state}}
          </div>
        </ion-col>
        <ion-col size="12" size-md="3" class="col-padding" v-if="zipcode">
          <ion-label class="section-item" position="stacked">
            Pincode
          </ion-label>
          <div class="section-desc margin-top-10">
            {{zipcode}}
          </div>
        </ion-col>
      </ion-row>
        </ion-col>
      </ion-row>
      
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { LocationService } from "../../service/location/location.service";

import { LocalStorage } from "../../data/localstorage";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError } from "../../service";

import { CorporateService } from "../../service/corporate/corporate.service";
import { CorporateDetails } from "../../entity/corporate/corporateDetails";
import { CorporateAddress } from '@/entity/corporate/corprateAddress';
import { CorporateState } from '@/entity/corporate/corporateState';
import { IonCol, IonGrid, IonLabel, IonRow, IonSpinner } from "@ionic/vue";

export default defineComponent ({
    name: 'corporateView',
    components: {
      IonGrid, IonRow, IonCol, IonLabel, IonSpinner
    },
    data() {
        return {
            loaderTab: false,
            corporateName: "",
            corporateAliasName: "",
            branch: "",
            mobile1: "",
            mobile2: "",
            email: "",
            faxNumber: "",
            landline: "",
            primaryContactPerson: "",
            secondaryContactPerson: "",
            gstNumber: "",
            panNo: "",
            status: "",
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            zipcode: ""
        }
    },
    async mounted() {
    if (this.$route.params.corporateId) {
      let corporateDetails = await new CorporateService().getCorporateDetailsById(
        this.$route.params.corporateId
      );
      this.fillCorporate(corporateDetails);
    }
    // let types = await new EVChargerService().chargerTypes();
    // let charger = await new EVChargerService().chargerWithId(
    //   this.$route.params.chargerId
    // );
    // if (charger) {
    //   this.charger = charger;
    //   let chargerType = types.find(
    //     chargerType => chargerType.id === charger.type.id
    //   );
    //   this.chargerType = chargerType;
    // }
    // console.log('this.chargerType :'+JSON.stringify(this.chargerType))
    this.loaderTab = false;
  },
  methods: {
    convertUppercase(value) {
      return value.toUpperCase()
    },
    fillCorporate(corporate) {
      this.corporateName = corporate.corporateName;
      this.corporateAliasName = corporate.corporateAliasName;
      this.branch = corporate.branch;
      this.mobile1 = corporate.mobilePrimaryContact;
      this.primaryContactPerson = corporate.primaryContactPerson;
      this.gstNumber = corporate.gstNumber;
      this.panNo = corporate.panNumber;
      this.email = corporate.email;
      this.status = corporate.status;
      this.mobile2 = corporate.mobileSecondaryContact;
      this.faxNumber = corporate.faxNumber;
      this.landline = corporate.landline;
      this.secondaryContactPerson = corporate.secondaryContactPerson
      this.line1 = corporate.addressLine1;
      this.line2 = corporate.addressLine2;
      this.line3 = corporate.addressLine3;
      this.city = corporate.city;
      this.state = corporate.state;
      this.zipcode = corporate.pincode;
    },
  }
})
</script>